// isTwelveHourTime
export default (groups) => /[a-z]/i.test(groups[groups.length - 1]);
